// Input clear button: https://github.com/skorecky/Add-Clear
import 'add-clear';

const searchPlayers = ($container) => {
  const container = $container || $('body');
  const $header = container.find($('@makePickSearch'));
  const $headerPresent = $header.length > 0;
  const $list = container.find($('@makePickList'));
  const hideDuration = 100;

  $.expr[':'].Contains = (el, i, m) => {
    const $item = $(el);
    const $teamName = $item.data('team_name');
    const $playerName = $item.find($('a.picks_item_player__name')).text();
    const string = `${$playerName} ${$teamName}`;

    return (string)
      .toUpperCase()
      .indexOf(m[3].toUpperCase() || '') >= 0;
  };

  function listFilter(header, list) {
    const form = $('<form>').attr({ class: 'simple_form simple_form-wide', action: '#' });
    const input = $('<input>').attr({ class: 'simple_form__search', type: 'text', placeholder: 'enter players name or team name', role: 'focus' });
    $(form).append(input).appendTo(header);

    const addClearSettings = {
      right: 10,
      showOnLoad: true,
      closeSymbol: '&#10006;',
      color: '#D90B4C',
      top: 2,
      paddingRight: 30,
      onClear() {
        $(input).trigger('change');
      },
    };

    $(input)
      .change(function() {
        const $this = $(this);
        const filter = $this.val();

        if (filter) {
          $(list).find(`li.picks_links_list__item:not(:Contains(${filter}))`).fadeOut(hideDuration);
          $(list).find(`li.picks_links_list__item:Contains(${filter})`).fadeIn(hideDuration);
        } else {
          $(list).find('li').fadeIn(hideDuration);
        }
        return false;
      })
      .keyup(function() {
        const $this = $(this);
        $this.change();
      })
      .addClear(addClearSettings);
  }

  if ($headerPresent) {
    listFilter($header, $list);
  }
};

export default searchPlayers;
